class EcStickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.lastScrollY = window.scrollY;
    this.scrollingUp = false;
    this.isSticky = false;
    this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
    this.headerHeight = 0;
    
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.lastScrollY = window.scrollY;
    this.calculateHeaderHeight();
    this.applyInitialStickyState();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
    requestAnimationFrame(() => {
      this.calculateHeaderHeight();
      this.applyInitialStickyState();
      requestAnimationFrame(() => {
        this.calculateHeaderHeight();
        this.applyInitialStickyState();
      });
    });
  }

  /** Evita “pulo”: header já entra como fixo quando o tema pede sticky (não só após o 1º scroll). */
  applyInitialStickyState() {
    if (this.stickyType === 'none') {
      this.setSticky(false);
      return;
    }
    const y = window.scrollY;
    if (this.stickyType === 'always') {
      this.setSticky(true);
      return;
    }
    if (this.stickyType === 'on-scroll-up') {
      const threshold = Math.max(this.headerHeight, this.offsetHeight, 1);
      if (y <= threshold) {
        this.classList.remove('scrolled-past-header');
        this.setSticky(true);
      } else {
        this.classList.add('scrolled-past-header');
        this.setSticky(false);
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  calculateHeaderHeight() {
    this.headerHeight = this.offsetHeight;
    const placeholder = document.querySelector('.ec-header-placeholder');
    if (placeholder) {
      placeholder.style.height = `${this.headerHeight}px`;
    }
  }

  handleScroll() {
    if (this.stickyType === 'none') {
      return;
    }

    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < this.lastScrollY;

    this.scrollingUp = scrollingUp;
    this.lastScrollY = currentScrollY;

    if (this.stickyType === 'always') {
      if (!this.isSticky) {
        this.setSticky(true);
      }
      return;
    }

    if (this.stickyType === 'on-scroll-up') {
      if (currentScrollY > this.headerHeight) {
        this.classList.add('scrolled-past-header');
        if (scrollingUp && !this.isSticky) {
          this.setSticky(true);
        } else if (!scrollingUp && this.isSticky) {
          this.setSticky(false);
        }
      } else {
        this.classList.remove('scrolled-past-header');
        this.setSticky(true);
      }
    }
  }

  handleResize() {
    this.calculateHeaderHeight();
    this.applyInitialStickyState();
  }

  setSticky(isSticky) {
    if (isSticky === this.isSticky) {
      return;
    }

    this.isSticky = isSticky;

    if (isSticky) {
      this.classList.add('sticky');
    } else {
      this.classList.remove('sticky');
    }
  }
}

if (!customElements.get('ec-sticky-header')) {
  customElements.define('ec-sticky-header', EcStickyHeader);
}

document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.ec-header__nav-item--has-mega');
  const menuInstances = [];
  
  const closeAllMenusExcept = (exceptItem) => {
    menuInstances.forEach(instance => {
      if (instance.item !== exceptItem) {
        clearTimeout(instance.hoverTimeout);
        instance.isHovered = false;
        instance.isMenuHovered = false;
        instance.navLink.setAttribute('aria-expanded', 'false');
        instance.megaMenu.style.transition = 'none';
        instance.megaMenu.style.opacity = '0';
        instance.megaMenu.style.visibility = 'hidden';
        instance.megaMenu.style.transform = 'translateY(-10px)';
        instance.megaMenu.style.pointerEvents = 'none';
        setTimeout(() => {
          instance.megaMenu.style.transition = '';
        }, 50);
      }
    });
  };
  
  navItems.forEach(item => {
    const navLink = item.querySelector('.ec-header__nav-link--has-mega');
    const megaMenu = item.querySelector('.ec-mega-menu');
    
    if (!navLink || !megaMenu) return;
    
    let hoverTimeout;
    let isHovered = false;
    let isMenuHovered = false;
    
    const menuInstance = {
      item,
      navLink,
      megaMenu,
      hoverTimeout,
      isHovered,
      isMenuHovered
    };
    menuInstances.push(menuInstance);
    
    const showMegaMenu = () => {
      closeAllMenusExcept(item);
      
      clearTimeout(hoverTimeout);
      isHovered = true;
      menuInstance.isHovered = true;
      navLink.setAttribute('aria-expanded', 'true');
      megaMenu.style.transition = '';
      megaMenu.style.opacity = '1';
      megaMenu.style.visibility = 'visible';
      megaMenu.style.transform = 'translateY(0)';
      megaMenu.style.pointerEvents = 'auto';
    };
    
    const hideMegaMenu = () => {
      hoverTimeout = setTimeout(() => {
        if (!isHovered && !isMenuHovered) {
          navLink.setAttribute('aria-expanded', 'false');
          megaMenu.style.opacity = '0';
          megaMenu.style.visibility = 'hidden';
          megaMenu.style.transform = 'translateY(-10px)';
          megaMenu.style.pointerEvents = 'none';
        }
      }, 100);
    };
    
    item.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      isHovered = true;
      menuInstance.isHovered = true;
      showMegaMenu();
    });
    
    item.addEventListener('mouseleave', (e) => {
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (megaMenu.contains(relatedTarget) || relatedTarget === megaMenu)) {
        isMenuHovered = true;
        menuInstance.isMenuHovered = true;
        return;
      }
      const otherNavItem = relatedTarget?.closest('.ec-header__nav-item--has-mega');
      if (otherNavItem && otherNavItem !== item) {
        clearTimeout(hoverTimeout);
        isHovered = false;
        isMenuHovered = false;
        menuInstance.isHovered = false;
        menuInstance.isMenuHovered = false;
        navLink.setAttribute('aria-expanded', 'false');
        megaMenu.style.transition = 'none';
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-10px)';
        megaMenu.style.pointerEvents = 'none';
        setTimeout(() => {
          megaMenu.style.transition = '';
        }, 50);
        return;
      }
      isHovered = false;
      menuInstance.isHovered = false;
      hideMegaMenu();
    });
    
    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      isMenuHovered = true;
      isHovered = true;
      menuInstance.isMenuHovered = true;
      menuInstance.isHovered = true;
      showMegaMenu();
    });
    
    megaMenu.addEventListener('mouseleave', (e) => {
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (item.contains(relatedTarget) || relatedTarget === item)) {
        isHovered = true;
        isMenuHovered = false;
        menuInstance.isHovered = true;
        menuInstance.isMenuHovered = false;
        return;
      }
      isMenuHovered = false;
      isHovered = false;
      menuInstance.isMenuHovered = false;
      menuInstance.isHovered = false;
      hideMegaMenu();
    });
    
    document.addEventListener('click', (e) => {
      if (!item.contains(e.target) && !megaMenu.contains(e.target)) {
        navLink.setAttribute('aria-expanded', 'false');
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-10px)';
        megaMenu.style.pointerEvents = 'none';
        isHovered = false;
        isMenuHovered = false;
        menuInstance.isHovered = false;
        menuInstance.isMenuHovered = false;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  
  if (!cartIconBubble) return;
  
  const customCartSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5756 5.51906C21.5052 5.43481 21.4172 5.36705 21.3177 5.32056C21.2183 5.27407 21.1098 5.24998 21 5.25H5.87625L5.30625 2.11594C5.27485 1.94313 5.1838 1.78681 5.04897 1.67425C4.91414 1.56169 4.74408 1.50003 4.56844 1.5H2.25C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25C1.5 2.44891 1.57902 2.63968 1.71967 2.78033C1.86032 2.92098 2.05109 3 2.25 3H3.9375L6.33375 16.1522C6.40434 16.5422 6.57671 16.9067 6.83344 17.2087C6.47911 17.5397 6.22336 17.9623 6.09455 18.4298C5.96575 18.8972 5.96892 19.3912 6.10371 19.8569C6.23851 20.3226 6.49966 20.7419 6.85821 21.0683C7.21676 21.3947 7.6587 21.6154 8.13502 21.7059C8.61134 21.7965 9.10344 21.7533 9.55673 21.5813C10.01 21.4092 10.4068 21.115 10.7031 20.7312C10.9994 20.3474 11.1836 19.889 11.2353 19.407C11.287 18.9249 11.2041 18.4379 10.9959 18H15.2541C15.0863 18.3513 14.9995 18.7357 15 19.125C15 19.6442 15.154 20.1517 15.4424 20.5834C15.7308 21.0151 16.1408 21.3515 16.6205 21.5502C17.1001 21.7489 17.6279 21.8008 18.1371 21.6996C18.6463 21.5983 19.114 21.3483 19.4812 20.9812C19.8483 20.614 20.0983 20.1463 20.1996 19.6371C20.3008 19.1279 20.2489 18.6001 20.0502 18.1205C19.8515 17.6408 19.5151 17.2308 19.0834 16.9424C18.6517 16.654 18.1442 16.5 17.625 16.5H8.54719C8.37155 16.5 8.20149 16.4383 8.06665 16.3257C7.93182 16.2132 7.84077 16.0569 7.80938 15.8841L7.51219 14.25H18.3872C18.9141 14.2499 19.4243 14.0649 19.8288 13.7272C20.2333 13.3896 20.5064 12.9206 20.6006 12.4022L21.7406 6.13406C21.7599 6.02572 21.7551 5.91447 21.7266 5.80818C21.6981 5.7019 21.6466 5.60319 21.5756 5.51906ZM9.75 19.125C9.75 19.3475 9.68402 19.565 9.5604 19.75C9.43679 19.935 9.26109 20.0792 9.05552 20.1644C8.84995 20.2495 8.62375 20.2718 8.40552 20.2284C8.18729 20.185 7.98684 20.0778 7.8295 19.9205C7.67217 19.7632 7.56502 19.5627 7.52162 19.3445C7.47821 19.1262 7.50049 18.9 7.58564 18.6945C7.67078 18.4889 7.81498 18.3132 7.99998 18.1896C8.18499 18.066 8.4025 18 8.625 18C8.92337 18 9.20952 18.1185 9.4205 18.3295C9.63147 18.5405 9.75 18.8266 9.75 19.125ZM18.75 19.125C18.75 19.3475 18.684 19.565 18.5604 19.75C18.4368 19.935 18.2611 20.0792 18.0555 20.1644C17.85 20.2495 17.6238 20.2718 17.4055 20.2284C17.1873 20.185 16.9868 20.0778 16.8295 19.9205C16.6722 19.7632 16.565 19.5627 16.5216 19.3445C16.4782 19.1262 16.5005 18.9 16.5856 18.6945C16.6708 18.4889 16.815 18.3132 17 18.1896C17.185 18.066 17.4025 18 17.625 18C17.9234 18 18.2095 18.1185 18.4205 18.3295C18.6315 18.5405 18.75 18.8266 18.75 19.125ZM19.125 12.1341C19.0935 12.3074 19.0021 12.464 18.8666 12.5766C18.7312 12.6893 18.5605 12.7506 18.3844 12.75H7.23938L6.14906 6.75H20.1009L19.125 12.1341Z" fill="currentColor"/>
  </svg>`;
  
  const preserveCustomCartIcon = () => {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    
    const customSvg = cartIcon.querySelector('svg[viewBox="0 0 24 24"]');
    const hasSvgWrapper = cartIcon.querySelector('.svg-wrapper');
    
    if (hasSvgWrapper || !customSvg) {
      const oldCount = cartIcon.querySelector('.cart-count-bubble') || cartIcon.querySelector('.ec-header__cart-count');
      const cartCount = oldCount ? oldCount.textContent.trim() : '';
      const cartCountHTML = cartCount ? `<span class="ec-header__cart-count">${cartCount}</span>` : '';
      
      const classes = cartIcon.className;
      const href = cartIcon.getAttribute('href');
      const ariaLabel = cartIcon.getAttribute('aria-label');
      const id = cartIcon.id;
      
      cartIcon.innerHTML = customCartSvg + cartCountHTML;
      
      cartIcon.className = classes;
      if (href) cartIcon.setAttribute('href', href);
      if (ariaLabel) cartIcon.setAttribute('aria-label', ariaLabel);
      if (id) cartIcon.id = id;
    }
  };
  
  const observer = new MutationObserver((mutations) => {
    let shouldFix = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.querySelector && node.querySelector('.svg-wrapper')) {
              shouldFix = true;
            } else if (node.classList && node.classList.contains('svg-wrapper')) {
              shouldFix = true;
            }
          }
        });
      }
    });
    if (shouldFix) {
      setTimeout(preserveCustomCartIcon, 10);
    }
  });
  
  observer.observe(cartIconBubble, {
    childList: true,
    subtree: true
  });
  
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (args[0] && (args[0].includes('cart') || args[0].includes('change'))) {
        setTimeout(preserveCustomCartIcon, 100);
      }
      return response;
    });
  };
  
  document.addEventListener('cart:updated', preserveCustomCartIcon);
  document.addEventListener('cart:refresh', preserveCustomCartIcon);
  
  preserveCustomCartIcon();
});

document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('ec-drawer-menu');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const closeButtons = document.querySelectorAll('[data-drawer-close]');
  
  if (!drawer || !menuToggle) return;

  const openDrawer = () => {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    const allDrawerLinks = drawer.querySelectorAll('.ec-drawer__link, .ec-drawer__submenu-link, .ec-drawer__button, .ec-drawer__action');
    allDrawerLinks.forEach(link => {
      link.blur();
      link.classList.remove('touch-active');
    });
  };

  menuToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    openDrawer();
  });

  const overlay = drawer.querySelector('.ec-drawer__overlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      closeDrawer();
    });
  }

  const closeButton = drawer.querySelector('.ec-drawer__close');
  if (closeButton) {
    const handleClose = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeDrawer();
    };
    
    closeButton.addEventListener('click', handleClose, true);
    
    const svg = closeButton.querySelector('svg');
    if (svg) {
      svg.addEventListener('click', handleClose, true);
      const path = svg.querySelector('path');
      if (path) {
        path.addEventListener('click', handleClose, true);
      }
    }
  }

  const drawerContent = drawer.querySelector('.ec-drawer__content');
  if (drawerContent) {
    drawerContent.addEventListener('click', (e) => {
      if (e.target === closeButton || e.target.closest('.ec-drawer__close')) {
        return;
      }
      e.stopPropagation();
    });
  }

  drawer.addEventListener('click', (e) => {
    if (e.target === drawer || e.target === overlay) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  const toggleButtons = document.querySelectorAll('[data-drawer-toggle]');
  toggleButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const item = button.closest('.ec-drawer__item--has-children');
      if (item) {
        item.classList.toggle('ec-drawer__item--expanded');
      }
      setTimeout(() => {
        button.blur();
        button.classList.remove('touch-active');
      }, 150);
    });

    button.addEventListener('touchstart', () => {
      button.classList.add('touch-active');
    });

    button.addEventListener('touchend', () => {
      setTimeout(() => {
        button.classList.remove('touch-active');
      }, 150);
    });
  });

  const allDrawerLinks = document.querySelectorAll('.ec-drawer__link, .ec-drawer__submenu-link, .ec-drawer__button, .ec-drawer__action');
  allDrawerLinks.forEach(link => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        this.blur();
        this.classList.remove('touch-active');
      }, 150);
    });

    link.addEventListener('touchstart', function() {
      this.classList.add('touch-active');
    });

    link.addEventListener('touchend', function() {
      setTimeout(() => {
        this.classList.remove('touch-active');
      }, 150);
    });

    link.addEventListener('blur', function() {
      this.classList.remove('touch-active');
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.ec-header');
  const normalContent = document.querySelector('.ec-header__inner--normal');
  const searchContent = document.querySelector('.ec-header__inner--search');
  const searchToggle = document.querySelectorAll('[data-search-toggle]');
  const searchCloseHeader = document.querySelectorAll('[data-search-close-header]');
  const searchInputHeader = document.querySelector('.ec-header__search-input');
  
  if (!header || !normalContent || !searchContent) return;

  const searchPopular = document.getElementById('ec-search-popular');
  
  const openHeaderSearch = () => {
    normalContent.style.display = 'none';
    searchContent.style.display = 'flex';
    header.classList.add('ec-header--search-mode');
    if (searchPopular) {
      searchPopular.style.display = 'block';
    }
    setTimeout(() => {
      if (searchInputHeader) {
        searchInputHeader.focus();
      }
    }, 100);
  };

  let closeHeaderSearch = () => {
    searchContent.style.display = 'none';
    normalContent.style.display = 'flex';
    header.classList.remove('ec-header--search-mode');
    if (searchPopular) {
      searchPopular.style.display = 'none';
    }
    if (searchInputHeader) {
      searchInputHeader.value = '';
      searchInputHeader.blur();
    }
  };
  
  let predictiveSearchCleanup = null;

  searchToggle.forEach(button => {
    button.addEventListener('click', (e) => {
      if (button.classList.contains('ec-header__icon--desktop') || button.classList.contains('ec-header__icon--mobile')) {
        e.stopPropagation();
        openHeaderSearch();
      }
    });
  });

  searchCloseHeader.forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      closeHeaderSearch();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchContent.style.display === 'flex') {
      closeHeaderSearch();
    }
  });

  document.addEventListener('click', (e) => {
    if (searchContent.style.display === 'flex') {
      const clickedElement = e.target;
      const headerElement = document.querySelector('.ec-header');
      const searchPopularElement = document.getElementById('ec-search-popular');
      
      if (headerElement && searchPopularElement) {
        const isClickInsideHeader = headerElement.contains(clickedElement);
        const isClickInsideSearchPopular = searchPopularElement.contains(clickedElement);
        
        if (!isClickInsideHeader && !isClickInsideSearchPopular) {
          closeHeaderSearch();
        }
      }
    }
  });
  
  if (searchInputHeader && searchPopular) {
    const checkPredictiveSearchCleanup = setInterval(() => {
      if (typeof window.ecPredictiveSearchCleanup === 'function') {
        predictiveSearchCleanup = window.ecPredictiveSearchCleanup;
        clearInterval(checkPredictiveSearchCleanup);
        
        const originalCloseHeaderSearch = closeHeaderSearch;
        closeHeaderSearch = function() {
          originalCloseHeaderSearch();
          if (predictiveSearchCleanup) {
            predictiveSearchCleanup();
          }
        };
      }
    }, 50);
    
    setTimeout(() => clearInterval(checkPredictiveSearchCleanup), 5000);
  }
  
});

document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('ec-drawer-menu');
  if (!drawer) return;
  
  const accordionTriggers = drawer.querySelectorAll('.ec-drawer__accordion-trigger');
  let currentOpenAccordion = null;

  accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const accordionContent = trigger.nextElementSibling;
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (currentOpenAccordion && currentOpenAccordion !== trigger) {
        currentOpenAccordion.setAttribute('aria-expanded', 'false');
        const prevContent = currentOpenAccordion.nextElementSibling;
        if (prevContent) {
          prevContent.style.maxHeight = '0';
          prevContent.style.overflow = 'hidden';
        }
      }

      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        accordionContent.style.maxHeight = '0';
        accordionContent.style.overflow = 'hidden';
        currentOpenAccordion = null;
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        accordionContent.style.overflow = 'visible';
        currentOpenAccordion = trigger;
      }
    });
  });
});
